<template>
    <div>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="650" :styles="{top: '100px'}">
        <Form ref="form" :model="form" :label-width="70" >
            <FormItem label="添加月数" prop="vipTime">
                <InputNumber v-model="form.vipTime" autocomplete="off"/>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="cancelUser">取消</Button>
            <Button type="primary" :loading="submitLoading" @click="handelSubmit">提交</Button>
        </div>
    </Modal>
    </div>
</template>

<script>
    import {addVip} from "@/api/bus";
    export default {
        name: "vipDrawer",
        components: {

        },
        data() {
            return {
                type:0,
                errorPass: "",
                deptLoading: false,
                modalTitle: "添加VIP",
                submitLoading: false,
                modalVisible: false,
                form: {
                    userId:"",
                    vipTime: 1,
                }
            }
        },
        methods: {
            init() {

            },
            showDrawer(params) {
                this.modalVisible = true;
                if (params.id) {
                    this.type = 1;
                    this.modalTitle = "添加VIP";
                    this.form.userId=params.id;
                }
            },
            cancelUser() {
                this.modalVisible = false;
            },
            handelSubmit() {
                if(this.form.vipTime < 1){
                    this.$Message.error("添加的vip月数不能小于1个月");
                    return;
                }
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.submitLoading = true;
                        // 添加 避免编辑后传入id等数据 记得删除
                        addVip(this.form).then(res => {
                            this.submitLoading = false;
                            if (res.status === true) {
                                this.$Message.success("添加成功");
                                this.$parent.getDataList();
                                this.modalVisible = false;
                            }
                        });
                    }
                });
            }
        },
        mounted() {

        }
    }
</script>

<style>

</style>